<template>
  <div v-show="visibleModule" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">cpu</h2>
    </div>  
    
    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3" style="width: 900px;">
        <ul v-for="item in CPUValue" :key="item.label" style="padding-left: 30px;width: 135px;">
          <li>{{ item.label }}</li>
          <li>{{ item.value }}</li>
        </ul>
      </div>

      <div v-show="hasData(usageDataFields)" class="position-relative mt-3"> 
        <div id="cpu_usage_line" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="cpu_usage_line_chart" />
        <chart-rect ref="chartRect1" chartKey="cpu_usage_line_chart" />
      </div>

      <div v-show="hasData(coreDataFields)" class="position-relative mt-3">
        <div class="position-relative"> 
          <div
            id="cpu_core_usage"
            style="width: 100%; height: 400px"
          ></div>
          <div id="cpu_core_usage_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
          <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="cpu_core_usage_chart " />
          <chart-rect ref="chartRect2" chartKey="cpu_core_usage_chart" />
        </div>
      </div>

      <div v-show="hasData(usageNormalizedDataFields)" class="position-relative mt-3">
        <div class="position-relative"> 
          <div
            id="cpu_usage_normalized"
            style="width: 100%; height: 400px"
          ></div>
          <div id="cpu_usage_normalized_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
          <label-list ref="labelList3" :perf_second_data="perf_second_data" chartKey="cpu_usage_normalized_chart" />
          <chart-rect ref="chartRect3" chartKey="cpu_usage_normalized_chart" />
        </div>
      </div>

      <div v-show="hasData(freqLineDataFields)" class="position-relative mt-3">
        <div class="position-relative"> 
          <div
            id="cpu_freq_line"
            style="width: 100%; height: 400px"
          ></div>
          <div id="cpu_freq_line_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
          <label-list ref="labelList4" :perf_second_data="perf_second_data" chartKey="cpu_freq_line_chart" />
          <chart-rect ref="chartRect4" chartKey="cpu_freq_line_chart" />
        </div>
      </div>

      <div v-show="hasData(clockDataFields)" class="position-relative mt-3">
        <div class="position-relative"> 
          <div id="cpu_clock" style="width: 100%; height: 400px"></div>
          <div id="cpu_clock_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
          <label-list ref="labelList5" :perf_second_data="perf_second_data" chartKey="cpu_clock_chart" />
          <chart-rect ref="chartRect5" chartKey="cpu_clock_chart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty} from '../common.js'
import ChartRect from '../rect.vue'

const useUsage = {
  data() {
    return {
      usageSeries: [
        {name: 'App', dataKey: 'AppCPU[%]'},
        {name: 'Total', dataKey: 'TotalCPU[%]'},
      ]
    }
  },

  computed: {
    usageDataFields() {
      return this.usageSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getCpuUsageOption() {
      return {
        title: {
          text: "CPU Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.usageSeries.map(item => {
          return {
            name: item.name,
            type: "line",
            showSymbol: false,
            data: this.secondData?.[item.dataKey],
            itemStyle: this.chartSettings.itemStyle2,
          }
        })
      }
    },

    drawPieChartCPUUsage() {
      let chartDom = document.getElementById("cpu_usage_line")
      if (!chartDom) return
      if (!allChart.cpu_usage_line_chart) {
        allChart.cpu_usage_line_chart = echarts.init(chartDom)
      }
      allChart.cpu_usage_line_chart.setOption(this.getCpuUsageOption(), {notMerge: true})
    },
  },
}

const useCoreUsage = {
  data() {
    return {
      coreUsageSeries: [
        {name: 'CPU0', dataKey: 'CPUUsage0[%]'},
        {name: 'CPU1', dataKey: 'CPUUsage1[%]'},
        {name: 'CPU2', dataKey: 'CPUUsage2[%]'},
        {name: 'CPU3', dataKey: 'CPUUsage3[%]'},
        {name: 'CPU4', dataKey: 'CPUUsage4[%]'},
        {name: 'CPU5', dataKey: 'CPUUsage5[%]'},
        {name: 'CPU6', dataKey: 'CPUUsage6[%]'},
        {name: 'CPU7', dataKey: 'CPUUsage7[%]'},
      ]
    }
  },

  computed: {
    coreDataFields() {
      return this.coreUsageSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getCore_usageOption() {
      return {
        title: {
          text: "CPU Core USage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.coreUsageSeries.map(item => {
          return {
            name: item.name,
            type: "line",
            showSymbol: false,
            data: this.secondData?.[item.dataKey],
            lineStyle: {
              width: 1,
            },
            emphasis: {
              lineStyle: {
                width: 1, // hover时的折线宽度
              },
            },
          }
        }),
      }
    },

    drawPieChartCPUCoreUsage() {
      let chartDom = document.getElementById("cpu_core_usage")
      if (!chartDom) return
      if (!allChart.cpu_core_usage_chart) {
        allChart.cpu_core_usage_chart = echarts.init(chartDom)
      }
      allChart.cpu_core_usage_chart.setOption(this.getCore_usageOption(), {notMerge: true})
    },
  },
}

const useUsageNormalized = {
  data() {
    return {
      usageNormalizedSeries: [
        {name: 'App', dataKey: 'AppCPU[%](Normalized)'},
        {name: 'Total', dataKey: 'TotalCPU[%](Normalized)'},
      ]
    }
  },

  computed: {
    usageNormalizedDataFields() {
      return this.usageNormalizedSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getCpuUsageNormalizedOption() {
      return {
        title: {
          text: "CPU Usage(Normalized)",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.usageNormalizedSeries.map(item => {
          return {
            name: item.name,
            type: "line",
            showSymbol: false,
            data: this.secondData?.[item.dataKey],
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawPieChartCPUUsageNormalized() {
      let chartDom = document.getElementById("cpu_usage_normalized")
      if (!chartDom) return
      if (!allChart.cpu_usage_normalized_chart) {
        allChart.cpu_usage_normalized_chart = echarts.init(chartDom)
      }
      allChart.cpu_usage_normalized_chart.setOption(this.getCpuUsageNormalizedOption(), {notMerge: true})
    },
  },
}

const useFreqLine = {
  data() {
    return {
      freqLineSeries: [
        {name: 'CPU0', dataKey: 'CPUUsage0[%](Normalized)'},
        {name: 'CPU1', dataKey: 'CPUUsage1[%](Normalized)'},
        {name: 'CPU2', dataKey: 'CPUUsage2[%](Normalized)'},
        {name: 'CPU3', dataKey: 'CPUUsage3[%](Normalized)'},
        {name: 'CPU4', dataKey: 'CPUUsage4[%](Normalized)'},
        {name: 'CPU5', dataKey: 'CPUUsage5[%](Normalized)'},
        {name: 'CPU6', dataKey: 'CPUUsage6[%](Normalized)'},
        {name: 'CPU7', dataKey: 'CPUUsage7[%](Normalized)'},
      ]
    }
  },

  computed: {
    freqLineDataFields() {
      return this.freqLineSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getFreq_lineOption() {
      return {
        title: {
          text: "CPU Core USage(Normalized)",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.freqLineSeries.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
            lineStyle: {
              width: 1,
            },
            emphasis: {
              lineStyle: {
                width: 1, // hover时的折线宽度
              },
            },
          }
        }),
      }
    },
    
    drawPieChartCPUFreq() {
      let chartDom = document.getElementById("cpu_freq_line")
      if (!chartDom) return
      if (!allChart.cpu_freq_line_chart) {
        allChart.cpu_freq_line_chart = echarts.init(chartDom)
      }
      allChart.cpu_freq_line_chart.setOption(this.getFreq_lineOption(), {notMerge: true})
    },
  },
}

const useClock = {
  data() {
    return {
      clockSeries: [
        {name: 'Clock0', dataKey: 'CPUClock0[MHz]'},
        {name: 'Clock1', dataKey: 'CPUClock1[MHz]'},
        {name: 'Clock2', dataKey: 'CPUClock2[MHz]'},
        {name: 'Clock3', dataKey: 'CPUClock3[MHz]'},
        {name: 'Clock4', dataKey: 'CPUClock4[MHz]'},
        {name: 'Clock5', dataKey: 'CPUClock5[MHz]'},
        {name: 'Clock6', dataKey: 'CPUClock6[MHz]'},
        {name: 'Clock7', dataKey: 'CPUClock7[MHz]'},
      ]
    }
  },

  computed: {
    clockDataFields() {
      return this.clockSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getCpu_clockOption() {
      return {
        title: {
          text: "CPU Clock",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.clockSeries.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
            lineStyle: {
              width: 1,
            },
            emphasis: {
              lineStyle: {
                width: 1, // hover时的折线宽度
              },
            },
          }
        }),
      }
    },

    drawPieChartCPUClock() {
      let chartDom = document.getElementById("cpu_clock")
      if (!chartDom) return
      if (!allChart.cpu_clock_chart) {
        allChart.cpu_clock_chart = echarts.init(chartDom)
      }
      allChart.cpu_clock_chart.setOption(this.getCpu_clockOption(), {notMerge: true})
    },
  },
}

export default {
  mixins: [useUsage, useCoreUsage, useUsageNormalized, useFreqLine, useClock],

  inject: ['injectObj', 'hasData'],

  components: {LabelList, ChartRect},

  props: {
    testInfo3: Object,
    testInfo: Object,
    chartSettings: Object,
    perf_second_data: Object,
  },
  
  data() {
    return {
    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    CPUValue() {
      // let data = this.testInfo
      // if (this.isAllChecked) { //如果选择标签的时候是全选，使用testInfo3的数据
      //   data = this.testInfo3
      // }
      let data = this.testInfo3

      return [
        {
          label: "Avg(AppCPU) [%]",
          value: data?.['Avg(AppCPU)[%]'] || '-',
        },
        {
          label: "AppCPU<=60% [%]",
          value: data?.['AppCPU<=60%[%]'] || '-',
        },
        {
          label: "AppCPU<=80% [%]",
          value: data?.['AppCPU<=80%[%]'] || '-',
        },
        {
          label: "Avg(TotalCPU) [%]",
          value: data?.['Avg(TotalCPU)[%]'] || '-',
        },
        {
          label: "TotalCPU<=60% [%]",
          value: data?.['TotalCPU<=60%[%]'] || '-',
        },
        {
          label: "TotalCPU<=80% [%]",
          value: data?.['TotalCPU<=80%[%]'] || '-',
        },
        {
          label: "Avg(AppCPU) [%]Normalized",
          value: data?.['Avg(AppCPU)[%]Normalized'] || '-',
        },
        {
          label: "AppCPU<=60%[%]Normalized",
          value: data?.['AppCPU<=60%[%]Normalized'] || '-',
        },
        {
          label: "AppCPU<=80%[%]Normalized",
          value: data?.['AppCPU<=80%[%]Normalized'] || '-',
        },
        {
          label: "Avg(TotalCPU) [%] Normalized",
          value: data?.['Avg(TotalCPU)[%]Normalized'] || '-',
        },
        {
          label: "TotalCPU<=60%[%] Normalized",
          value: data?.['TotalCPU<=60%[%]Normalized'] || '-',
        },
        {
          label: "TotalCPU<=80%[%] Normalized",
          value: data?.['TotalCPU<=80%[%]Normalized'] || '-',
        },
        // {
        //   label: "Avg(Process CPU)[%]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
        // },
        // {
        //   label: "Avg(Total CPU)[%]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu_total,
        // },
        // {
        //   label: "CPU<=60[%]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
        // },
        // {
        //   label: "CPU<=80[%]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_80_pcnt,
        // },
        // {
        //   label: "Avg(CTemp)[°C])",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_temp,
        // },
        // {
        //   label: "Avg(AppCPU)[%]Normalized",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.app_cpu_normalized,
        // },
        // {
        //   label: "Avg(TotalCPU)[%]Normalized",
        //   value:
        //     JSON.stringify(data) === "{}" ? "-" : data?.total_cpu_normalized,
        // },
      ];
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    labelsHasData() {
      return arrNotEmpty(this.CPUValue)
    },

    visibleModule() {
      return this.labelsHasData || this.hasData(this.usageDataFields) || this.hasData(this.coreDataFields) || this.hasData(this.usageNormalizedDataFields) || this.hasData(this.freqLineDataFields) || this.hasData(this.clockDataFields)
    },
  },

  methods: {
    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
      this.$refs.chartRect3?.init(isMounted)
      this.$refs.chartRect4?.init(isMounted)
      this.$refs.chartRect5?.init(isMounted)
    },

    drawCharts() {
      this.drawPieChartCPUUsage()
      this.drawPieChartCPUCoreUsage()
      this.drawPieChartCPUUsageNormalized()
      this.drawPieChartCPUFreq()
      this.drawPieChartCPUClock()
    },
  }
}
</script>

<style scoped>
@import "../common.css"
</style>